export default {
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    externalError: {
      required: false,
      default: null,
    },
    width: {
      type: Number,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fieldType: 'text',
      changed: this.$attrs.value ? true : false,
    }
  },
  computed: {
    entity() {
      return this.$parent.entity || this.$parent.$parent.entity || this.$parent.$parent.$parent.entity
    },
    fields() {
      return this.$parent.fields || this.$parent.$parent.fields || this.$parent.$parent.$parent.fields
    },
    field() {
      return this.fields[this.fieldName]
    },
    error() {
      return this.field.error || this.externalError
    },
    hasError() {
      return Boolean(this.error)
    },
    isInvalid() {
      return Boolean(this.error && this.changed)
    },
    isValid() {
      return Boolean(!this.error && this.changed)
    },
    isCreated() {
      return Boolean(this.entity.created)
    },
    icon() {
      return this.changed ? (this.hasError ? 'red ban' : 'green check') : null
    },
    tooltip() {
      return (this.entity.comments && this.entity.comments[this.fieldName]) || this.field.tooltip || null
    },
    fieldPlaceholder() {
      return this.placeholder || this.field.placeholder || ''
    },
  },
  methods: {
    onInput() {
      if (!this.field.readonly) {
        this.$emit('input', this.$attrs.value)
        this.changed = true
      }
    },
    set(value) {
      if (!this.field.readonly) {
        this.$attrs.value = value
        this.onInput()
      }
    },
  },
}
